import { createAuth0Client, Auth0Client } from "@auth0/auth0-spa-js";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios, { AxiosRequestConfig, AxiosError } from "axios";

export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    redirect_uri: window.location.origin,
  },
  cacheLocation: "localstorage" as const,
  onRedirectCallback: (appState?: any) => {
    window.history.replaceState(
      {},
      document.title,
      appState?.returnTo || window.location.pathname,
    );
  },
};

let client: Auth0Client;

const getAuthClient = async () => {
  if (!client) {
    client = await createAuth0Client(auth0Config);
  }
  return client;
};

interface CustomArgs extends AxiosRequestConfig {
  devPort?: string;
  // This allows us to pass the token from the component call if needed,
  baseUrl?: string;
}

const getBaseURL = (devPort?: string) => {
  const protocol = process.env.REACT_APP_ENV !== "dev" ? "https://" : "http://";
  const endpoint = process.env.REACT_APP_BACKEND_ENDPOINT || "";
  const base = protocol + endpoint;

  if (devPort && process.env.REACT_APP_ENV === "dev") {
    return base.slice(0, -4) + devPort;
  }
  return base;
};

export const axiosBaseQuery =
  (): BaseQueryFn<CustomArgs, unknown, unknown> =>
  async ({ url, method, data, params, headers, devPort }) => {
    try {
      const auth0 = await getAuthClient();
      const token = await auth0.getTokenSilently();

      const result = await axios({
        url: getBaseURL(devPort) + url,
        method,
        data,
        params,
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
